import { motion } from 'framer-motion';
import { useCallback, useEffect, useRef } from 'react';
import homeImg from '../assets/start.webp';
import { useFormContext } from '../context/FormContextProvider';
import { Qvariants } from '../data/variants';

const Home = () => {
  const { setTab } = useFormContext();

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const keyHandler = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      buttonRef.current?.click();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keypress', (e) => keyHandler(e));

    return () => document.removeEventListener('keypress', (e) => keyHandler(e));
  }, [keyHandler]);

  return (
    <motion.main className='home' variants={Qvariants} exit='exit'>
      <figure className='home__img--wrapper'>
        <img src={homeImg} className='home__img' alt='home page' />
      </figure>
      <h1 className='title'>Tell us a story.</h1>
      <div className='button--wrapper'>
        <button
          ref={buttonRef}
          className='button'
          onClick={() => setTab((state) => state + 1)}
        >
          Start
        </button>
        <p className='button__helper'>
          press <strong>Enter ↵</strong>
        </p>
      </div>
    </motion.main>
  );
};

export default Home;
